import { SYS_BREAKPOINT_2_XL, SYS_BREAKPOINT_LG, SYS_BREAKPOINT_MD, SYS_BREAKPOINT_SM, SYS_BREAKPOINT_XL, SYS_BREAKPOINT_XS, SYS_MAX_CONTENT_WIDTH } from '../../tokens/sizing.generated.js';
import { SYS_PAGE_MARGIN_2_XL, SYS_PAGE_MARGIN_LG, SYS_PAGE_MARGIN_MD, SYS_PAGE_MARGIN_SM, SYS_PAGE_MARGIN_XL, SYS_PAGE_MARGIN_XS } from '../../tokens/spacing.generated.js';
import { createGlobalStyle } from 'styled-components';
import { systemSpaceRelative } from '../theme-provider/theme/tokens/index.js';
import { SYS_COLOR_CANVAS_200_LIGHT } from '../../tokens/color.light.generated.js';
import { SYS_COLOR_CANVAS_200_DARK } from '../../tokens/color.dark.generated.js';
const breakpointObject = {
    xs: SYS_BREAKPOINT_XS,
    sm: SYS_BREAKPOINT_SM,
    md: SYS_BREAKPOINT_MD,
    lg: SYS_BREAKPOINT_LG,
    xl: SYS_BREAKPOINT_XL,
    xxl: SYS_BREAKPOINT_2_XL
};
const generateScopedVariables = (varsPerBreakpoint, breakpoints) => {
    let css = '';
    const prevValues = {};
    for (const [breakpoint, vars] of Object.entries(varsPerBreakpoint)) {
        let breakpointCss = '';
        vars.forEach((varObj) => {
            const [key, value] = Object.entries(varObj)[0] ?? [];
            if (value && key && (!prevValues[key] || prevValues[key] !== value)) {
                breakpointCss += `--spacing-relative-${key}: ${value};\n`;
                prevValues[key] = value;
            }
        });
        if (breakpoint === 'xs') {
            css += breakpointCss;
        }
        else if (breakpointCss) {
            css += `\n@media (min-width: ${breakpoints[breakpoint]}) {\n${breakpointCss}}\n`;
        }
    }
    return css;
};
const getGlobalStylesCSS = (props) => `
  body {
    margin: 0;
    ${props?.hasGlobalBackgroundColor && props?.themeName === 'dark'
    ? `background-color: ${SYS_COLOR_CANVAS_200_DARK}`
    : `background-color: ${SYS_COLOR_CANVAS_200_LIGHT}`}
  }

  body:has(dialog[open]) {
    overflow: hidden;
  }

  @font-face {
    font-family: 'AudiType';
    src: url('https://assets.one.audi/assets/fonts/AudiTypeVF.woff2')
      format('woff2-variations');
    font-display: swap;
    font-style: normal;
    font-stretch: 100% 130%;
  }

  :root {
    --max-content-width: ${SYS_MAX_CONTENT_WIDTH};
    --page-margin: ${SYS_PAGE_MARGIN_XS};

    @media (min-width: ${SYS_BREAKPOINT_SM}) {
      --page-margin: ${SYS_PAGE_MARGIN_SM};
    }

    @media (min-width: ${SYS_BREAKPOINT_MD}) {
      --page-margin: ${SYS_PAGE_MARGIN_MD};
    }

    @media (min-width: ${SYS_BREAKPOINT_LG}) {
      --page-margin: ${SYS_PAGE_MARGIN_LG};
    }

    @media (min-width: ${SYS_BREAKPOINT_XL}) {
      --page-margin: ${SYS_PAGE_MARGIN_XL};
    }

    @media (min-width: ${SYS_BREAKPOINT_2_XL}) {
      --page-margin: ${SYS_PAGE_MARGIN_2_XL};
    }

    @property --gradient-start {
      syntax: '<color>';
      initial-value: transparent;
      inherits: false;
    }

    @property --gradient-end {
      syntax: '<color>';
      initial-value: transparent;
      inherits: false;
    }

    ${generateScopedVariables(systemSpaceRelative, breakpointObject)}
  }
`;
export const getGlobalStyleAsString = (props) => getGlobalStylesCSS(props);
export const GlobalStyles = createGlobalStyle `${(props) => getGlobalStylesCSS(props)}`;
//# sourceMappingURL=index.js.map